import type { ActivityModule } from '../../core/activity';
import { mountComparator } from './ui';
import levelsData from './levels.json';
import './style.css';

export const comparator: ActivityModule = {
  id: 'comparator',
  title: 'Comparar números',
  description: 'Compare os números e escolha o sinal correto (<, =, >). Cada rodada tem 5 pares pra você marcar.',
  ageMin: 6,
  ageMax: 11,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/comparator/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountComparator,
};
